export default __webpack_public_path__ + "static/media/Srisailam.ff1f7ced.webp";